// AA – Shared helpers
(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function onPageLoaded(fn) {
    document.addEventListener('page:loaded', fn);
    ready(fn);
  }

  function getCartTrigger() {
    return document.querySelector('toggle-cart [href="' + window.Shopify.routes.root + 'cart"]');
  }

  function openThemeCartDrawer() {
    var trigger = getCartTrigger();
    if (!trigger) return;
    if (trigger.getAttribute('aria-expanded') === 'true') return;
    trigger.click();
  }

  function buildCart() {
    document.dispatchEvent(new CustomEvent('cart:build'));
  }

  window.AAThemeHelpers = {
    ready: ready,
    onPageLoaded: onPageLoaded,
    openThemeCartDrawer: openThemeCartDrawer,
    buildCart: buildCart
  };
})();


// AA – Blog scroll progress (safe on pages without the bar)
(function () {
  function initProgressBar(root) {
    root = root || document;

    var bar = root.getElementById
      ? root.getElementById('scroll-progress')
      : document.getElementById('scroll-progress');

    if (!bar || !bar.style) return;
    if (bar.dataset.progressInit === 'true') return;
    bar.dataset.progressInit = 'true';

    function getScrollableHeight() {
      var doc = document.documentElement;
      return Math.max(doc.scrollHeight - doc.clientHeight, 1);
    }

    var scrollableHeight = getScrollableHeight();
    var ticking = false;

    function onScroll() {
      if (ticking) return;
      ticking = true;

      requestAnimationFrame(function () {
        var doc = document.documentElement;
        var body = document.body;
        var scrollTop = (body && body.scrollTop) || doc.scrollTop || 0;
        var pct = (scrollTop / scrollableHeight) * 100;

        if (pct < 0) pct = 0;
        if (pct > 100) pct = 100;

        bar.style.width = pct + '%';
        ticking = false;
      });
    }

    function onResize() {
      scrollableHeight = getScrollableHeight();
      onScroll();
    }

    onResize();

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
  }

  AAThemeHelpers.onPageLoaded(function () {
    initProgressBar(document);
  });

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target || document;
    if (root.querySelector && root.querySelector('#scroll-progress')) {
      initProgressBar(root);
    }
  });
})();


// AA Reveal v1.0 – sitewide reveal-on-scroll
(() => {
  const SELECTOR_ITEM = '.aa-reveal';
  const SELECTOR_GROUP = '.aa-reveal-group';
  const DEFAULT_GROUP_INTERVAL_MS = 140;

  const setupGroupCascade = (group) => {
    const interval = parseInt(group.getAttribute('data-aa-group-interval') || DEFAULT_GROUP_INTERVAL_MS, 10);
    const items = group.querySelectorAll(SELECTOR_ITEM);
    items.forEach((el, i) => {
      el.style.setProperty('--aa-group-delay', (i * interval) + 'ms');
    });
  };

  document.querySelectorAll(SELECTOR_GROUP).forEach(setupGroupCascade);

  const defaultOptions = {
    root: null,
    threshold: 0,
    rootMargin: '0px 0px -1% 0px'
  };

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const items = document.querySelectorAll(SELECTOR_ITEM);

  if (reduceMotion) {
    items.forEach((el) => el.classList.add('is-visible'));
    return;
  }

  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const el = entry.target;
      const repeat = (el.getAttribute('data-aa-repeat') || 'false').toLowerCase() === 'true';

      if (entry.isIntersecting) {
        el.classList.add('is-visible');
        if (!repeat) io.unobserve(el);
      } else if (repeat) {
        el.classList.remove('is-visible');
      }
    });
  }, defaultOptions);

  items.forEach((el) => io.observe(el));

  const mo = new MutationObserver((muts) => {
    muts.forEach((m) => {
      m.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;

        if (node.matches?.(SELECTOR_GROUP)) setupGroupCascade(node);
        node.querySelectorAll?.(SELECTOR_GROUP).forEach(setupGroupCascade);

        const newItems = [];
        if (node.matches?.(SELECTOR_ITEM)) newItems.push(node);
        node.querySelectorAll?.(SELECTOR_ITEM).forEach((el) => newItems.push(el));

        newItems.forEach((el) => {
          if (reduceMotion) {
            el.classList.add('is-visible');
          } else {
            io.observe(el);
          }
        });
      });
    });
  });

  mo.observe(document.documentElement, { childList: true, subtree: true });
})();


// Recipe Kit Cart Event Listener
document.addEventListener(
  'rk_cart_event',
  function () {
    AAThemeHelpers.buildCart();
  },
  false
);


// Cart Samples
(function () {
  var reduceSamplesBusy = false;
  var reduceSamplesQueued = false;

  function getCart(callback) {
    jQuery.getJSON(window.Shopify.routes.root + 'cart.js', callback);
  }

  function setText(id, value) {
    var el = document.getElementById(id);
    if (el) el.textContent = value;
  }

  function setDisplay(id, show) {
    var el = document.getElementById(id);
    if (el) el.style.display = show ? 'block' : 'none';
  }

  function countMiniItems(cart) {
    var sampleCount = 0;

    for (var i = 0; i < cart.items.length; i++) {
      var currentItemTitle = cart.items[i].title || '';
      if (currentItemTitle.includes('Mini')) {
        sampleCount += cart.items[i].quantity;
      }
    }

    return sampleCount;
  }

  function displayAvailableSamples(cart) {
    var cartTotalPriceS = cart.total_price / 100;
    var sampleCount = countMiniItems(cart);
    var availableSamples = Math.floor(cartTotalPriceS / 50) - sampleCount;

    setText('samplesAvailable', availableSamples);
    setDisplay('freeSamples', availableSamples > 0);

    setText('samplesAvailableMain', availableSamples);
    setDisplay('freeSamplesMain', availableSamples > 0);
  }

  function myCustomFunction() {
    getCart(displayAvailableSamples);
  }

  function removeMiniProducts() {
    if (reduceSamplesBusy) {
      reduceSamplesQueued = true;
      return;
    }

    reduceSamplesBusy = true;
    reduceSamplesQueued = false;

    jQuery.getJSON(window.Shopify.routes.root + 'cart.js', function (cart) {
      var itemsToReduce = {};
      var cartTotalPriceS = cart.total_price / 100;
      var sampleCount = countMiniItems(cart);
      var availableSamples = Math.floor(cartTotalPriceS / 50) - sampleCount;

      cart.items.forEach(function (item, idx) {
        if (idx >= 1) return;

        if ((item.title || '').includes('Mini') && availableSamples < 0) {
          var qty = item.quantity - 1 > -1 ? item.quantity - 1 : 0;
          itemsToReduce[item.id] = qty;

          if (qty === 0) {
            var $el = jQuery('[data-key="' + item.key + '"]');
            $el.remove();
          }
        }
      });

      if (Object.keys(itemsToReduce).length > 0) {
        jQuery
          .post(window.Shopify.routes.root + 'cart/update.js', {
            updates: itemsToReduce
          })
          .then(function () {
            AAThemeHelpers.buildCart();
          })
          .always(function () {
            reduceSamplesBusy = false;
            if (reduceSamplesQueued) {
              removeMiniProducts();
            }
          });
      } else {
        reduceSamplesBusy = false;
        if (reduceSamplesQueued) {
          removeMiniProducts();
        }
      }
    }).fail(function () {
      reduceSamplesBusy = false;
    });
  }

  function reduceSamples() {
    removeMiniProducts();
  }

  document.addEventListener('cart:updated', myCustomFunction);
  document.addEventListener('ajaxProduct:added', myCustomFunction);

  document.addEventListener('cart:updated', reduceSamples);
  document.addEventListener('ajaxProduct:added', reduceSamples);

  AAThemeHelpers.onPageLoaded(function () {
    myCustomFunction();
  });
})();


// Clear Cart
(function () {
  function getCartWithSections() {
    var root = window.Shopify.routes.root;

    return Promise.all([
      jQuery.getJSON(root + 'cart.js'),
      fetch(root + '?section_id=cart-ajax', {
        credentials: 'same-origin',
        method: 'GET'
      }).then(function (res) {
        return res.text();
      })
    ]).then(function (results) {
      var cart = results[0];
      var cartAjaxMarkup = results[1];

      cart.sections = cart.sections || {};
      cart.sections['cart-ajax'] = cartAjaxMarkup;

      return cart;
    });
  }

  function clearCartAndSync(shouldReload) {
    var root = window.Shopify.routes.root;

    jQuery.post(root + 'cart/clear.js')
      .then(function () {
        return getCartWithSections();
      })
      .then(function (cart) {
        // Rebuild drawer/page cart markup
        AAThemeHelpers.buildCart();

        // Update cart bubble + any theme listeners that expect sections['cart-ajax']
        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            detail: { cart: cart }
          })
        );

        // Keep your other custom listeners in sync
        document.dispatchEvent(
          new CustomEvent('rk_cart_event', {
            detail: { cart: cart }
          })
        );

        if (shouldReload) {
          location.reload();
        }
      });
  }

  function clearCart(e) {
    if (e) e.preventDefault();
    clearCartAndSync(false);
  }

  function clearCartMain(e) {
    if (e) e.preventDefault();
    clearCartAndSync(true);
  }

  AAThemeHelpers.onPageLoaded(function () {
    var clearCartBtn = document.getElementById('clearCartBtn');
    var clearCartBtnMain = document.getElementById('clearCartBtnMain');

    if (clearCartBtn && !clearCartBtn.dataset.aaBoundClear) {
      clearCartBtn.dataset.aaBoundClear = 'true';
      clearCartBtn.addEventListener('click', clearCart);
    }

    if (clearCartBtnMain && !clearCartBtnMain.dataset.aaBoundClear) {
      clearCartBtnMain.dataset.aaBoundClear = 'true';
      clearCartBtnMain.addEventListener('click', clearCartMain);
    }
  });
})();

// AA – Prevent cart drawer focus from scrolling the page
(function () {
  if (window.__aaCartPreventScrollFocusInstalled) return;
  window.__aaCartPreventScrollFocusInstalled = true;

  var cartOpening = false;
  var cartOpen = false;

  function isCartElement(el) {
    return !!(
      el &&
      el.closest &&
      el.closest('#HeaderCart, header-cart-drawer, .site-header__drawer, .cart-drawer')
    );
  }

  var originalFocus = HTMLElement.prototype.focus;

  HTMLElement.prototype.focus = function (options) {
    var shouldPrevent =
      isCartElement(this) &&
      (cartOpening || cartOpen);

    if (shouldPrevent) {
      try {
        return originalFocus.call(this, Object.assign({}, options || {}, { preventScroll: true }));
      } catch (e) {
        try {
          return originalFocus.call(this);
        } catch (err) {}
      }
    }

    return originalFocus.call(this, options);
  };

  // manual cart open
  document.addEventListener(
    'click',
    function (e) {
      if (e.target.closest('#HeaderCartTrigger')) {
        cartOpening = true;
        setTimeout(function () {
          cartOpening = false;
        }, 800);
      }
    },
    true
  );

  // auto-open after product add
  document.addEventListener('ajaxProduct:added', function () {
    cartOpening = true;
    setTimeout(function () {
      cartOpening = false;
    }, 800);
  });

  document.addEventListener('cart:open', function () {
    cartOpening = true;
  });

  document.addEventListener('drawerOpen', function () {
    cartOpen = true;
    setTimeout(function () {
      cartOpening = false;
    }, 150);
  });

  document.addEventListener('cart:close', function () {
    cartOpen = false;
    cartOpening = false;
  });

  window.addEventListener('keyup', function (e) {
    if (e.key === 'Escape') {
      cartOpen = false;
      cartOpening = false;
    }
  });
})();

// AA – Prevent clickable samples

(function() {
  function disableHiddenProductLinks(scope) {
    var root = scope || document;

    var links = root.querySelectorAll('a[data-hide-product="true"]');

    links.forEach(function(link) {
      if (link.dataset.hideProductProcessed === 'true') return;
      link.dataset.hideProductProcessed = 'true';

      link.removeAttribute('href');
      link.setAttribute('aria-disabled', 'true');
      link.setAttribute('tabindex', '-1');
      link.style.pointerEvents = 'none';
      link.style.cursor = 'default';
      link.style.textDecoration = 'none';
    });
  }

  function runHiddenProductLinkDisabler() {
    disableHiddenProductLinks(document);
  }

  document.addEventListener('DOMContentLoaded', runHiddenProductLinkDisabler);
  document.addEventListener('shopify:section:load', runHiddenProductLinkDisabler);

  var observer = new MutationObserver(function(mutations) {
    var shouldRun = mutations.some(function(mutation) {
      return mutation.addedNodes && mutation.addedNodes.length > 0;
    });

    if (shouldRun) {
      disableHiddenProductLinks(document);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();